import { HttpClient } from '@angular/common/http';
import { Component, OnInit, QueryList, ViewChildren, AfterViewChecked, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { PgModalService } from 'pg-lib/pg-ui-elements/pg-modal.service';
import { AnalyticsService } from 'pg-lib/services/analytics.service';
import { AuthService } from 'pg-lib/services/auth.service';
import { EFDataService } from 'pg-lib/services/ef-data.service';
import { EFProduct } from 'pg-lib/models/experience.model';
import { EnvironmentService } from 'pg-lib/services/environment.service';
import { GoogleMapsService } from 'pg-lib/services/google-maps.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { TitleService } from 'pg-lib/services/title.service';
import { TravelDataService } from 'pg-lib/services/travel-data.service';
import { WeatherService } from 'pg-lib/services/weather.service';
import { PGUtilities } from 'pg-lib/utilities/pg-utilities';
import { TotemScreensaverData } from '../../elements/totem-screensaver/totem-screensaver.component';
import { TotemWidget } from '../../widgets/totem-widget';
import { TotemWidgetActivitiesComponent } from '../../widgets/totem-widget-activities/totem-widget-activities.component';
import { TotemWidgetChallengeComponent } from '../../widgets/totem-widget-challenge/totem-widget-challenge.component';
import { TotemWidgetDetailsComponent } from '../../widgets/totem-widget-details/totem-widget-details.component';
import { TotemWidgetDestinationComponent } from '../../widgets/totem-widget-destination/totem-widget-destination.component';
import { TotemWidgetDaySurveyComponent } from '../../widgets/totem-widget-day-survey/totem-widget-day-survey.component';
import { TotemWidgetWeatherComponent } from '../../widgets/totem-widget-weather/totem-widget-weather.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DEFAULT_TOTEM_CONFIG, TotemHomeTourPhase, TotemHomeTourPhaseConfig } from './totem-home.config';
import {  Subscription, firstValueFrom } from 'rxjs';
import { TotemProductComponent } from '../../elements/totem-product/totem-product.component';
import { TravelDetail, TravelListItem } from 'pg-lib/models/travel.model';

export class TotemHomeVariables {
    weather = {
        sunny: false,
        rainy: false,
        intense_heat: false
    }
}

class TotemHomeComponentWidgetData {
    id?:string;
    name: string;
    title: string;
    params?: any;
    size?:'md'|'lg';
    color?:string;
    condition?:string;
}

@Component({
    selector: 'app-totem-home',
    templateUrl: './totem-home.component.html',
    styleUrls: ['./totem-home.component.scss'],
    standalone: false
})
export class TotemHomeComponent implements OnInit, OnDestroy, AfterViewChecked {

    constructor(private http:HttpClient, private efDataService:EFDataService, private environmentService:EnvironmentService, private route:ActivatedRoute, private router:Router, private localizationService:LocalizationService, private authService:AuthService, private modalService:PgModalService, private analyticsService:AnalyticsService, private weatherService:WeatherService, private titleService:TitleService, private googleMapsService:GoogleMapsService, private travelDataService:TravelDataService) { }

    isLoading = false;

    productsData:Array<EFProduct> = null;

    configData = null;
    currentTravel:TravelDetail = null;
    travelList:TravelListItem[] = [];
    travelOptions:Array<{ value: string; text: string }> = [];
    selectedTravelId:string = null;
    hasNoTravels = false;

    widgetList:Array<TotemHomeComponentWidgetData> = []

    fadeWidgets = false;
    private _fadeWidgetsTimeout = null;

    /** Hide/recreate map background during phase refresh to avoid stale map flashing back in. */
    showBackgroundMap = true;

    currentLocation:string = null;
    currentCoordinates:{ lat: number, lon: number } = null;

    homeVariables:TotemHomeVariables = null;

    openSection:string = 'home';

    private _refreshWeatherTimeout = null;
    private _refreshWeatherDelay = 15 * 60 * 1000;

    fadeSplashScreen = false;
    showSplashScreen = false;

    @ViewChild('splashSkipButton') splashSkipButton:ElementRef<HTMLButtonElement>;
    @ViewChild('fullScreenBackButton') fullScreenBackButton:ElementRef<HTMLButtonElement>;
    @ViewChild('productBackButton') productBackButton:ElementRef<HTMLButtonElement>;

    private _overlayFocusReturn:HTMLElement = null;
    private _overlayFocusPending:'splash'|'fullscreen'|'product' = null;
    private _activeOverlay:'splash'|'fullscreen'|'product' = null;

    ngOnInit(): void {
        this.isLoading = true;

        this._initHome().then(() => {
            let _title = null;

            if(this.configData != null) {
                _title = PGUtilities.stripHTML(this.localizationService.translate(this.configData.title))
            }

            this.titleService.setTitle(_title)

            this._handleFragment(this.route.snapshot.fragment, true);

            this.isLoading = false;

            this.authService.afterLogin.subscribe(() => {
                this._loadTourOperatorData().then(() => {})
            })

            console.log('loadProducts')

            this._loadProducts().then(() => {
            })
        }, () => {
            this.isLoading = false;
        })

        this.route.fragment.subscribe((fragment) => {
            if(!this.isLoading) {
                this._handleFragment(fragment);
            }
        })
    }

    ngOnDestroy() {
        this.titleService.setTitle()
    }

    private _handleFragment(fragment:string, isInit?:boolean) {
        if(fragment != null && fragment != '') {
            let _split = fragment.split('/')
            this._handleFragmentWidget(_split[0], _split[1])
        }
        else {
            this._handleFragmentWidget(null, null)
        }
    }

    private _handleFragmentWidget(widget:string, params:string) {
        const _hadProduct = this.viewProductId != null || this._activeOverlay == 'product';
        this.viewProductId = null;
        if(_hadProduct && widget != 'product') {
            this._closeOverlayFocus('product');
        }

        if(widget) {
            if(widget == 'product') {
                this._openOverlayFocus('product');
                this.viewProductId = params;
            }
            else {
                let _target:TotemHomeComponentWidgetData = null;

                for(let _item of this.widgetList) {
                    if(_item.id == widget || _item.name == 'totem-widget-' + widget) {
                        _target = _item;
                        break;
                    }
                }

                if(_target) {
                    clearTimeout(this._toggleFullScreenTimeout)

                    this._toggleFullScreenTimeout = setTimeout(() => {
                        this.fullScreenWidget = _target
                        if(params != null && params !== '') {
                            let _decoded = decodeURIComponent(params)
                            let _parsed = PGUtilities.tryParseJSON(_decoded, true)
                            this.fullScreenParams = _parsed != null ? _parsed : _decoded
                        }
                        else {
                            this.fullScreenParams = null
                        }

                        this._openOverlayFocus('fullscreen');
                        this.showFullScreen = true;
                    }, 250)
                }
            }
        }
        else {
            const _wasFullScreen = this.showFullScreen || this._activeOverlay == 'fullscreen';
            this.showFullScreen = false;

            this._toggleFullScreenTimeout = setTimeout(() => {
                this.fullScreenWidget = null;
                this.fullScreenParams = null;
                if(_wasFullScreen) this._closeOverlayFocus('fullscreen');
            }, 500)
        }
    }

    viewProductId:string = null; 

    viewProductBack() {
        this.router.navigate(['.'], { fragment: this._getFragment(), relativeTo: this.route })
    }

    private _loadProducts() {
        return new Promise<void>((resolve, reject) => {
            this.productsData = null;

            let _productsByType:{
                [type: string]: EFProduct[];
            } = null;
            
            this.efDataService.listProducts(null, null, null, null).subscribe((data) => {
                _productsByType = data;
            }, () => {
            }, () => {
                this.productsData = [];

                for(let i in _productsByType) {
                    if(_productsByType[i] != null) {
                        for(let _product of _productsByType[i]) {
                            this.productsData.push(_product)
                        }
                    }
                }

                resolve()
            })
        })
    }

    /**
     * Shell config is a static default for now.
     * Later we may override fields from environment.
     */
    private async _initHome() {
        this.configData = { ...DEFAULT_TOTEM_CONFIG };

        this.currentLocation = null;
        this.currentCoordinates = null;
        this.homeVariables = new TotemHomeVariables();

        clearTimeout(this._refreshWeatherTimeout)

        if(this.configData.splashScreen) {
            this.fadeSplashScreen = false;
            this._openOverlayFocus('splash');
            this.showSplashScreen = true;
        }

        await this._checkLocation();
        await this._loadTourOperatorData();

        this._isTotemLoaded = true;
        this.resetInactivity();
    }

    @ViewChild('splashScreenVideoElement') splashScreenVideoElement:ElementRef

    onSplashScreenLoad (result:boolean) {
        if(result) {
            let _video = this.splashScreenVideoElement.nativeElement as HTMLVideoElement
            _video.classList.remove('TotemHome-SplashScreen-Video--NotLoaded')

            _video.addEventListener('ended', () => {
                this.dismissSplashScreen();
            })

            if(this.prefersReducedMotion()) {
                this.showSplashScreen = false;
                this._closeOverlayFocus('splash');
                return;
            }

            _video.muted = true;
            _video.play().then(() => {}, () => {
                this.showSplashScreen = false;
                this._closeOverlayFocus('splash');
            })
        }
        else {
            this.showSplashScreen = false;
            this._closeOverlayFocus('splash');
        }
    }

    dismissSplashScreen() {
        if(!this.showSplashScreen) return;

        const _video = this.splashScreenVideoElement?.nativeElement as HTMLVideoElement;
        if(_video) {
            try { _video.pause(); } catch(e) {}
        }

        this.fadeSplashScreen = true;
        setTimeout(() => {
            this.fadeSplashScreen = false;
            this.showSplashScreen = false;
            this._closeOverlayFocus('splash');
        }, 250)
    }

    prefersReducedMotion() {
        return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    private _focusWithoutScroll(el:HTMLElement) {
        if(el == null || typeof el.focus !== 'function') return;
        try {
            el.focus({ preventScroll: true });
        }
        catch(e) {
            try { el.focus(); } catch(e2) {}
        }
    }

    private _openOverlayFocus(kind:'splash'|'fullscreen'|'product') {
        if(this._activeOverlay == null && typeof document !== 'undefined') {
            this._overlayFocusReturn = document.activeElement as HTMLElement;
        }
        this._activeOverlay = kind;
        this._overlayFocusPending = kind;
    }

    private _closeOverlayFocus(kind:'splash'|'fullscreen'|'product') {
        if(this._activeOverlay != kind) return;
        this._activeOverlay = null;
        this._overlayFocusPending = null;
        const _return = this._overlayFocusReturn;
        this._overlayFocusReturn = null;
        setTimeout(() => this._focusWithoutScroll(_return), 0);
    }

    private _applyOverlayFocus() {
        if(this._overlayFocusPending == null) return;

        let _target:HTMLElement = null;
        if(this._overlayFocusPending == 'splash') {
            _target = this.splashSkipButton?.nativeElement;
        }
        else if(this._overlayFocusPending == 'fullscreen') {
            _target = this.fullScreenBackButton?.nativeElement;
        }
        else if(this._overlayFocusPending == 'product') {
            _target = this.productBackButton?.nativeElement;
        }

        if(_target) {
            this._overlayFocusPending = null;
            setTimeout(() => this._focusWithoutScroll(_target), 0);
        }
    }

    @HostListener('document:keydown', ['$event'])
    onDocumentKeydown(event: KeyboardEvent) {
        if(this.showSplashScreen && (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            this.dismissSplashScreen();
            return;
        }

        if(this.screenSaverData != null && (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            this.resetInactivity();
            return;
        }

        // Escape chiude solo overlay dismissibili (non la login NgbModal, che resta keyboard:false)
        if(event.key === 'Escape') {
            if(this.viewProductId) {
                event.preventDefault();
                this.viewProductBack();
                return;
            }
            if(this.showFullScreen) {
                event.preventDefault();
                this.hideFullScreen();
            }
        }
    }

    tourPhase:TotemHomeTourPhase = null;

    private _tourPhaseLabel(phase: TotemHomeTourPhase) {
        return this.localizationService.translate('totem-home.tour-phase-' + phase);
    }

    selectedTourDay: string = null;
    /** Resolved clean destination for the selected during day (for challenges, weather, …). */
    selectedTourDayDestination: string = null;
    tourDayOptions: Array<{ value: string; text: string; location?: string }> = [];
    tourSteps: Array<{
        id: string;
        phase: TotemHomeTourPhase;
        dayIndex?: number;
        location?: string;
        label: string;
    }> = [];
    selectedTourStepId: string = null;
    private _pendingTourDayApply = false;
    private _preserveTourDayOnReload = false;
    /** In devMode the header selector can override the date-based phase. */
    private _tourPhaseManuallySelected = false;

    goToSection(val:string) {
        this.openSection = val || 'home';
    }

    shiftTourStep(offset: number) {
        if (!this.tourSteps.length) {
            this._rebuildTourSteps();
        }
        if (!this.tourSteps.length) return;

        let num = this.tourSteps.findIndex((step) => step.id === this.selectedTourStepId);
        if (num < 0) num = 0;

        num = (num + offset) % this.tourSteps.length;
        if (num < 0) num += this.tourSteps.length;

        this.goToTourStep(this.tourSteps[num]);
    }

    goToTourStep(step: { id: string; phase: TotemHomeTourPhase; dayIndex?: number; location?: string; label: string }) {
        if (!step) return;

        const phaseChanged = step.phase !== this.tourPhase;
        this.selectedTourStepId = step.id;

        if (step.phase === 'during' && step.dayIndex != null) {
            this.selectedTourDay = String(step.dayIndex);
            this._preserveTourDayOnReload = true;
            this._syncSelectedTourDayDestination();
        }
        else {
            this.selectedTourDay = null;
            this.selectedTourDayDestination = null;
            this._preserveTourDayOnReload = false;
        }

        if (phaseChanged) {
            this._tourPhaseManuallySelected = true;
            this.tourPhase = step.phase;
            this.onTourPhaseChange();
            return;
        }

        if (this.tourPhase === 'during') {
            this.applyTourDaySelection();
        }
    }

    getSelectedTourStepLabel(): string {
        const step = this.tourSteps.find((item) => item.id === this.selectedTourStepId);
        if (step?.label) return step.label;
        return this.tourPhase ? this._tourPhaseLabel(this.tourPhase) : '';
    }

    onTourPhaseChange() {
        this.showFullScreen = false;
        this.fullScreenWidget = null;
        this.fullScreenParams = null;
        this.goToSection('home');

        this.router.navigate(['.'], { fragment: this._getFragment(), relativeTo: this.route })

        this._loadTourOperatorData().then(() => {})
    }

    /** Raw location string from the selected program day. */
    getSelectedTourDayLocation(): string {
        if (this.tourPhase !== 'during' || this.selectedTourDay == null) return null;
        const option = this.tourDayOptions.find((item) => item.value === this.selectedTourDay);
        return option?.location || null;
    }

    /**
     * Resolved destination for the selected tour day.
     * Matches the day location against tour destinations (exact, then endsWith), else destinations[0].
     * Shared by challenges and any other location-based widgets.
     */
    getSelectedTourDayDestination(): string {
        if (this.tourPhase !== 'during') return null;

        const destinations = this.getTourDestinations();
        if (!destinations.length) return this.getSelectedTourDayLocation();

        return this._resolveTourDestinationFromDayLocation(this.getSelectedTourDayLocation(), destinations)
            || destinations[0];
    }

    /**
     * Unique destinations known for the current tour.
     * Does not include raw program day.location strings (those can be compound, e.g. "A / B / C").
     */
    getTourDestinations(): string[] {
        const destinations: string[] = [];
        const push = (value: string) => {
            const trimmed = value?.trim();
            if (!trimmed) return;
            if (destinations.some((item) => item.toLowerCase() === trimmed.toLowerCase())) return;
            destinations.push(trimmed);
        };

        const travel = this.currentTravel;
        for (const location of travel?.destination?.locations || []) {
            push(location?.name);
        }
        for (const destination of travel?.travel_challenges?.destinations || []) {
            push(destination);
        }
        for (const destination of travel?.packing_tips?.destinations || []) {
            push(destination);
        }

        return destinations;
    }

    applyTourDaySelection() {
        if (this.tourPhase !== 'during' || this.selectedTourDay == null) return;

        const index = Number(this.selectedTourDay);
        if (Number.isNaN(index)) return;

        this._syncSelectedTourDayDestination();

        const activities = this.widgetComponents?.find((item) => item instanceof TotemWidgetActivitiesComponent) as TotemWidgetActivitiesComponent;
        activities?.scrollToDay(index);

        const challenge = this.widgetComponents?.find((item) => item instanceof TotemWidgetChallengeComponent) as TotemWidgetChallengeComponent;
        if (this.selectedTourDayDestination && challenge) {
            challenge.setDestination(this.selectedTourDayDestination);
        }

        this._refreshTravelDetailsForSelectedDay();
        this._refreshDayLocationWeatherWidgets();

        const daySurvey = this.widgetComponents?.find(
            (item) => item instanceof TotemWidgetDaySurveyComponent,
        ) as TotemWidgetDaySurveyComponent;
        daySurvey?.applyDayKey(this.selectedTourDay);
    }

    private _syncSelectedTourDayDestination() {
        if (this.tourPhase !== 'during' || this.selectedTourDay == null) {
            this.selectedTourDayDestination = null;
            return;
        }
        this.selectedTourDayDestination = this.getSelectedTourDayDestination();
    }

    /** YYYY-MM-DD for the selected during day, or null outside during / without a day. */
    getSelectedTourDayDateKey(): string | null {
        if (this.tourPhase !== 'during' || this.selectedTourDay == null) return null;
        const index = Number(this.selectedTourDay);
        if (Number.isNaN(index)) return null;
        const entry = this._getTourDayEntries()[index];
        if (!entry?.date) return null;
        const parsed = new Date(entry.date);
        if (Number.isNaN(parsed.getTime())) {
            const raw = String(entry.date).trim();
            return /^\d{4}-\d{2}-\d{2}/.test(raw) ? raw.slice(0, 10) : null;
        }
        const y = parsed.getFullYear();
        const m = String(parsed.getMonth() + 1).padStart(2, '0');
        const d = String(parsed.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + d;
    }

    private _refreshTravelDetailsForSelectedDay() {
        if (!this.currentTravel) return;
        const onDate = this.getSelectedTourDayDateKey();
        const details = this.travelDataService.transportToDetailList(
            this.currentTravel,
            onDate ? { onDate } : undefined,
        );

        for (const widget of this.widgetList || []) {
            if (widget.name === 'totem-widget-details'
                && (widget.id === 'customization-details' || widget.id === 'departure-logistic-details')) {
                widget.params = { ...(widget.params || {}), detailList: details };
            }
        }

        const detailsWidget = this.widgetComponents?.find(
            (item) => item instanceof TotemWidgetDetailsComponent,
        ) as TotemWidgetDetailsComponent;
        if (detailsWidget) {
            detailsWidget.detailList = details;
        }
    }

    private _refreshDayLocationWeatherWidgets() {
        const dayLocation = this.selectedTourDayDestination;
        const dayDate = this.getSelectedTourDayDateKey();
        if (!dayLocation && !dayDate) return;

        for (const widget of this.widgetList || []) {
            if (widget.name === 'totem-widget-destination') {
                widget.params = {
                    ...(widget.params || {}),
                    ...(dayLocation ? { location: dayLocation } : {}),
                    ...(dayDate ? { date: dayDate } : {}),
                    showCountdown: false,
                    showTime: false,
                };
            }
            if (widget.name === 'totem-widget-weather' && dayLocation) {
                widget.params = { ...(widget.params || {}), location: dayLocation };
            }
        }

        if (dayLocation) {
            this.currentLocation = dayLocation;
        }

        const destinationWidget = this.widgetComponents?.find(
            (item) => item instanceof TotemWidgetDestinationComponent,
        ) as TotemWidgetDestinationComponent;
        if (destinationWidget) {
            if (dayLocation) destinationWidget.location = dayLocation;
            if (dayDate) destinationWidget.date = dayDate;
            destinationWidget.showCountdown = false;
            destinationWidget.showTime = false;
            destinationWidget.reload();
        }

        const weatherWidget = this.widgetComponents?.find(
            (item) => item instanceof TotemWidgetWeatherComponent,
        ) as TotemWidgetWeatherComponent;
        if (weatherWidget && dayLocation) {
            weatherWidget.location = dayLocation;
            weatherWidget.ngOnChanges();
        }
    }

    /**
     * Match a program day location against tour destinations:
     * exact, then destination.endsWith(dayLocation), then dayLocation.endsWith(destination)
     * (for compound day locations like "Salvador da Bahia / Sao Paulo / Roma").
     * Prefers the longest match.
     */
    private _resolveTourDestinationFromDayLocation(dayLocation: string, destinations: string[]): string | null {
        const needle = dayLocation?.trim();
        if (!needle || !destinations?.length) return null;

        const needleLower = needle.toLowerCase();

        for (const value of destinations) {
            if (value === needle || value.toLowerCase() === needleLower) return value;
        }

        let best: string = null;
        for (const value of destinations) {
            const hay = value.toLowerCase();
            if (!hay) continue;
            if (hay.endsWith(needleLower) || needleLower.endsWith(hay)) {
                if (!best || value.length > best.length) best = value;
            }
        }
        return best;
    }

    private _getTourDayEntries(config?: Array<any>): Array<{ date?: string; day?: number; location?: string }> {
        if (this.currentTravel) {
            const fromTravel = this.travelDataService.programToActivityList(this.currentTravel);
            if (fromTravel.length) return fromTravel;
        }

        const fromConfig = (config || this.widgetList || []).find((widget) =>
            widget.id === 'during-activities' || widget.name === 'totem-widget-activities');
        if (fromConfig?.params?.activityList?.length) {
            return fromConfig.params.activityList;
        }

        const duringConfig = TotemHomeTourPhaseConfig.getPhaseConfig(
            'during',
            this.localizationService.currentLanguage,
            (id) => this.localizationService.translate(id, null, null, true),
        );
        const activitiesWidget = (duringConfig || []).find((widget) =>
            widget.id === 'during-activities' || widget.name === 'totem-widget-activities');
        return activitiesWidget?.params?.activityList || [];
    }

    private _rebuildTourSteps(config?: Array<any>) {
        const list = this._getTourDayEntries(config);

        this.tourDayOptions = list.map((day, index) => ({
            value: String(index),
            text: this._formatTourDayLabel(day, index),
            location: day.location || null,
        }));

        this.tourSteps = [{
            id: 'before',
            phase: 'before',
            label: this._tourPhaseLabel('before'),
        }];

        if (list.length) {
            for (let i = 0; i < list.length; i++) {
                this.tourSteps.push({
                    id: 'during-' + i,
                    phase: 'during',
                    dayIndex: i,
                    location: list[i].location || null,
                    label: this._formatTourDayLabel(list[i], i),
                });
            }
        }
        else {
            this.tourSteps.push({
                id: 'during',
                phase: 'during',
                label: this._tourPhaseLabel('during'),
            });
        }

        this.tourSteps.push({
            id: 'after',
            phase: 'after',
            label: this._tourPhaseLabel('after'),
        });

        this._syncSelectedTourStep(list);
    }

    private _syncSelectedTourStep(list: Array<{ date?: string; day?: number; location?: string }>) {
        if (this.tourPhase === 'during') {
            let dayIndex = this.selectedTourDay != null ? Number(this.selectedTourDay) : NaN;

            if (!this._preserveTourDayOnReload || Number.isNaN(dayIndex) || dayIndex < 0 || dayIndex >= list.length) {
                dayIndex = this._defaultTourDayIndex(list);
            }

            if (list.length) {
                this.selectedTourDay = String(dayIndex);
                this.selectedTourStepId = 'during-' + dayIndex;
                this._syncSelectedTourDayDestination();
                this._pendingTourDayApply = true;
                this._preserveTourDayOnReload = false;
                return;
            }

            this.selectedTourDay = null;
            this.selectedTourDayDestination = null;
            this.selectedTourStepId = 'during';
            this._pendingTourDayApply = false;
            this._preserveTourDayOnReload = false;
            return;
        }

        this.selectedTourDay = null;
        this.selectedTourDayDestination = null;
        this.selectedTourStepId = this.tourPhase || 'before';
        this._pendingTourDayApply = false;
        this._preserveTourDayOnReload = false;
    }

    private _defaultTourDayIndex(list: Array<{ date?: string }>) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        for (let i = 0; i < list.length; i++) {
            if (!list[i].date) continue;
            const dayDate = new Date(list[i].date);
            dayDate.setHours(0, 0, 0, 0);
            if (dayDate.getTime() === today.getTime()) return i;
        }

        return 0;
    }

    private _formatTourDayLabel(day: { date?: string; day?: number; location?: string }, index: number) {
        const dayNum = day.day != null ? day.day : (index + 1);
        const dayLabel = this.localizationService.translate('totem-home.tour-day', { num: dayNum });
        if (day.location) {
            return dayLabel + ' - ' + day.location;
        }
        return dayLabel;
    }

    viaggiareSicuriData:any = null;

    hasTourPhaseSelector() {
        return !this.environmentService.production && !this.hasNoTravels
    }

    hasTravelSelector() {
        return this.travelList.length > 1;
    }

    getSelectedTravelLabel(): string {
        const option = this.travelOptions.find((item) => item.value === this.selectedTravelId);
        return option?.text || '';
    }

    shiftTravel(offset: number) {
        if (!this.travelOptions.length) return;

        let index = this.travelOptions.findIndex((item) => item.value === this.selectedTravelId);
        if (index < 0) index = 0;

        index = (index + offset) % this.travelOptions.length;
        if (index < 0) index += this.travelOptions.length;

        this.onTravelChange(this.travelOptions[index].value);
    }

    onTravelChange(travelId: string) {
        if (travelId == null || travelId === this.selectedTravelId) return;
        this.selectedTravelId = travelId;
        this._tourPhaseManuallySelected = false;
        this._loadTourOperatorData(Number(travelId)).then(() => {});
    }

    private _syncTravelSelectionState(list: TravelListItem[], travel: TravelDetail | null) {
        this.travelList = list || [];
        this.hasNoTravels = this.travelDataService.isEnabled()
            && this.travelDataService.isLoggedIn()
            && this.travelList.length === 0;
        this.travelOptions = this.travelList.map((item) => ({
            value: String(item.id),
            text: this._formatTravelOptionLabel(item),
        }));
        this.selectedTravelId = travel?.id != null
            ? String(travel.id)
            : (this.travelList[0] ? String(this.travelList[0].id) : null);
    }

    private _formatTravelOptionLabel(item: TravelListItem) {
        if (item?.title?.trim()) return item.title.trim();
        const location = item?.destination?.locations?.[0]?.name?.trim();
        const country = item?.destination?.country?.trim();
        if (location && country && location.toLowerCase() !== country.toLowerCase()) {
            return location + ', ' + country;
        }
        return location || country || item?.practice_id || ('#' + item.id);
    }

    private _startOfDay(value: string | Date): Date {
        const date = value instanceof Date ? new Date(value) : new Date(value);
        if (Number.isNaN(date.getTime())) return null;
        date.setHours(0, 0, 0, 0);
        return date;
    }

    private _resolveTourPhaseFromTravel(travel: TravelDetail | null): TotemHomeTourPhase {
        const period = travel?.travel_period || travel?.content?.travel_period;
        const departure = period?.departure_date ? this._startOfDay(period.departure_date) : null;
        if (!departure) return 'before';

        const today = this._startOfDay(new Date());
        if (today.getTime() < departure.getTime()) return 'before';

        let returnDate: Date = null;
        if (period?.return_date) {
            returnDate = this._startOfDay(period.return_date);
        }
        else if (period?.days != null && period.days > 0) {
            returnDate = new Date(departure);
            returnDate.setDate(returnDate.getDate() + period.days - 1);
        }
        else {
            const program = travel?.content?.program;
            if (program?.length) {
                const maxDay = Math.max(...program.map((day) => day.day || 1));
                returnDate = new Date(departure);
                returnDate.setDate(returnDate.getDate() + Math.max(0, maxDay - 1));
            }
        }

        if (returnDate != null && today.getTime() > returnDate.getTime()) return 'after';
        return 'during';
    }

    private _loadTourOperatorDataSubscriptions:Array<Subscription> = []

    private _loadTourOperatorData(preferredTravelId?: number) {
        return new Promise<void>((resolve, reject) => {
            clearTimeout(this._fadeWidgetsTimeout)

            for(let _item of this._loadTourOperatorDataSubscriptions) {
                _item.unsubscribe()
            }

            this.fadeWidgets = true;
            this.areWidgetsInitialized = false;
            this.showBackgroundMap = false;
            
            this._fadeWidgetsTimeout = setTimeout(async () => {
                if(this.travelDataService.isEnabled() && this.travelDataService.isLoggedIn()) {
                    try {
                        this.currentTravel = await firstValueFrom(
                            this.travelDataService.loadCurrentTravel(preferredTravelId)
                        );
                        this._syncTravelSelectionState(this.travelDataService.travelList, this.currentTravel);
                    }
                    catch(ex) {
                        console.warn('Travel load failed, using phase widget config only', ex);
                        this.currentTravel = null;
                        this._syncTravelSelectionState([], null);
                    }
                }
                else {
                    this.currentTravel = null;
                    this.travelList = [];
                    this.travelOptions = [];
                    this.selectedTravelId = null;
                    this.hasNoTravels = false;
                }

                if (this.hasNoTravels) {
                    this.tourPhase = null;
                    this._loadTourOperatorDataFinish([]);
                    resolve();
                    return;
                }

                if (this.environmentService.production || !this._tourPhaseManuallySelected || this.tourPhase == null) {
                    this.tourPhase = this._resolveTourPhaseFromTravel(this.currentTravel);
                }

                let _config = TotemHomeTourPhaseConfig.getPhaseConfig(
                    this.tourPhase,
                    this.localizationService.currentLanguage,
                    (id) => this.localizationService.translate(id, null, null, true),
                )

                if(this.currentTravel) {
                    _config = await this._applyTravelDataToWidgets(_config, this.currentTravel);
                }

                this.viaggiareSicuriData = {};

                let _reqCount = 0;

                for(let _widget of _config) {
                    let _country = _widget.params?.country
                    if(_country) {
                        _reqCount++
                        this._loadTourOperatorDataSubscriptions.push(this.http.get(this.environmentService.environment.EntouranceAPIUrl + '/travel/viaggiare-sicuri/' + _country).subscribe((data:any) => {
                            this.viaggiareSicuriData[_country] = data;
                            _reqCount--;
                            if(_reqCount == 0) {
                                this._loadTourOperatorDataFinish(_config)
                                resolve()
                            }
                        }, () => {
                            _reqCount--;
                            if(_reqCount == 0) {  
                                this._loadTourOperatorDataFinish(_config)
                                resolve()
                            }
                        }))
                    }
                } 
                
                if(_reqCount == 0) {  
                    this._loadTourOperatorDataFinish(_config)
                    resolve()
                }
            }, 250)
        })
    }

    private async _applyTravelDataToWidgets(config:Array<any>, travel:TravelDetail) {
        const packing = this.travelDataService.packingToCheckList(travel);
        const challenges = this.travelDataService.challengesToChallengeList(travel);
        const detailsOnDate = this.tourPhase === 'during' ? this.getSelectedTourDayDateKey() : null;
        const details = this.travelDataService.transportToDetailList(
            travel,
            detailsOnDate ? { onDate: detailsOnDate } : undefined,
        );
        const activities = this.travelDataService.programToActivityList(travel);
        const insuranceProducts = this.travelDataService.insuranceToProductsData(
            travel,
            this.localizationService.currentLanguage,
        );
        const departure = travel.travel_period?.departure_date;
        const firstLocation = travel.destination?.locations?.[0]
            || (travel.packing_tips?.destinations?.[0]
                ? { name: travel.packing_tips.destinations[0] }
                : null);

        const geo = await this._resolveTravelDestinationGeo(travel, firstLocation);
        const locationLabel = geo.locationLabel
            || this._formatTravelLocationLabel(firstLocation, travel.destination?.country);
        const coordinates = geo.coordinates;

        // Resolve ISO country via Google Geocoder from travel.destination.country (name or code).
        // Fall back to country from destination-location geocode.
        let countryAlpha3 = geo.countryAlpha3;
        let countryName = geo.countryName
            || this._countryDisplayName(geo.countryAlpha2)
            || countryAlpha3;

        if(travel.destination?.country) {
            const fromCountry = await this._geocodeCountryName(travel.destination.country);
            if(fromCountry.countryAlpha3) {
                countryAlpha3 = fromCountry.countryAlpha3;
                countryName = fromCountry.countryName
                    || this._countryDisplayName(countryAlpha3)
                    || countryAlpha3;
            }
        }

        if(locationLabel) {
            this.currentLocation = locationLabel;
        }
        if(coordinates) {
            this.currentCoordinates = coordinates;
        }

        return config.map((widget) => {
            const next = { ...widget, params: { ...(widget.params || {}) } };

            if(widget.name === 'totem-widget-checklist' && (widget.id === 'departure-pack-tips' || widget.id === 'departure-before-leaving') && packing.length) {
                next.params.checkList = packing;
                next.params.useTravelPacking = true;
                next.params.travelId = travel.id;
                next.params.editable = true;
            }

            if(widget.name === 'totem-widget-challenge') {
                next.params.challengeList = challenges;
                next.params.useTravelChallenges = true;
                next.params.travelId = travel.id;
                next.params.editable = true;
            }

            if(widget.name === 'totem-widget-details' && (widget.id === 'customization-details' || widget.id === 'departure-logistic-details')) {
                next.params.detailList = details;
            }

            if(widget.name === 'totem-widget-activities' && widget.id === 'during-activities') {
                next.params.activityList = activities;
            }

            if(widget.name === 'totem-widget-countdown' && departure) {
                next.params.date = departure;
            }

            if(widget.name === 'totem-widget-destination') {
                // before: departure countdown + tour location
                // during: selected day date + clean dayDestination (no countdown/time)
                if (this.tourPhase === 'during') {
                    this._syncSelectedTourDayDestination();
                }
                const dayLocation = this.tourPhase === 'during'
                    ? this.selectedTourDayDestination
                    : null;
                const dayDate = this.tourPhase === 'during'
                    ? this.getSelectedTourDayDateKey()
                    : null;

                if (this.tourPhase === 'before' && departure) {
                    next.params.date = departure;
                    next.params.showCountdown = true;
                    next.params.showTime = true;
                }
                else if (this.tourPhase === 'during' && dayDate) {
                    next.params.date = dayDate;
                    next.params.showCountdown = false;
                    next.params.showTime = false;
                }
                else {
                    delete next.params.date;
                    delete next.params.showCountdown;
                    delete next.params.showTime;
                }

                if (dayLocation || locationLabel) {
                    next.params.location = dayLocation || locationLabel;
                }
            }

            if(widget.name === 'totem-widget-identity') {
                next.title = null;
                if(travel.title) next.params.name = travel.title;
                const client = travel.content?.client || travel.client;
                if(client?.name) next.params.providedBy = client.name;
                if(client?.email) next.params.email = client.email;
                if(client?.phone) next.params.phone = client.phone;
                delete next.params.abstract;
                delete next.params.description;
                delete next.params.contact;
            }

            if(widget.name === 'totem-widget-weather') {
                if (this.tourPhase === 'during') {
                    this._syncSelectedTourDayDestination();
                }
                const weatherLocation = (this.tourPhase === 'during'
                    ? this.selectedTourDayDestination
                    : null) || locationLabel;
                if (weatherLocation) {
                    next.params.location = weatherLocation;
                }
            }

            if(widget.name === 'totem-widget-text' && widget.id === 'after-traveller-profile') {
                const completed = travel.progress?.challenge_results?.completed_count ?? 0;
                const total = travel.progress?.challenge_results?.total
                    || challenges.length
                    || 0;
                if(total > 0) {
                    const percent = Math.round((completed / total) * 100);
                    const lang = (this.localizationService.currentLanguage || 'it').toLowerCase();
                    next.params.overtitle = lang.startsWith('it')
                        ? ('Hai completato il ' + percent + '% delle sfide!')
                        : ('You\'ve completed ' + percent + '% of the challenges!');
                }
            }

            if(widget.name === 'totem-widget-viaggiare-sicuri'
                || widget.name === 'totem-widget-checklist'
                || next.params.country != null) {
                if(countryAlpha3) {
                    next.params.country = countryAlpha3;
                    if(countryName) {
                        next.params.countryName = countryName;
                    }
                }
                else {
                    delete next.params.country;
                    delete next.params.countryName;
                }
            }

            if(widget.name === 'totem-widget-products' && widget.id === 'customization-travel-insurance' && insuranceProducts.length) {
                next.params.productsData = insuranceProducts;
            }

            if(widget.name === 'totem-widget-products' && Array.isArray(next.params.productsData)) {
                next.params.productsData = next.params.productsData.map((product: any) => {
                    if(product?.id !== 'custom_location') {
                        return product;
                    }
                    const updated = { ...product };
                    if(firstLocation?.name || locationLabel) {
                        updated.title = firstLocation?.name || locationLabel;
                    }
                    if(coordinates) {
                        updated.geolocation = {
                            type: 'Point',
                            coordinates: [coordinates.lat, coordinates.lon],
                        };
                    }
                    return updated;
                });
            }

            return next;
        });
    }

    /** Resolve ISO alpha-3 + display name via Google Geocoder (works with names or codes). */
    private async _geocodeCountryName(country:string): Promise<{ countryAlpha3:string|null, countryName:string|null }> {
        try {
            await this.googleMapsService.loadMaps();
            const geocoder = new google.maps.Geocoder();
            const forward = await geocoder.geocode({ address: country.trim() });
            const result = forward.results?.find((r) =>
                r.address_components?.some((c) => c.types?.indexOf('country') !== -1)
            ) || forward.results?.[0];
            if(!result) return { countryAlpha3: null, countryName: null };

            const countryComponent = result.address_components?.find((c) => c.types?.indexOf('country') !== -1);
            const countryAlpha2 = countryComponent?.short_name || null;
            return {
                countryAlpha3: PGUtilities.countryAlpha2ToAlpha3(countryAlpha2),
                countryName: countryComponent?.long_name || null,
            };
        }
        catch(ex) {
            console.warn('Travel country geocode failed', ex);
            return { countryAlpha3: null, countryName: null };
        }
    }

    /** Resolve destination coords + ISO alpha-3 country via Google Geocoder. */
    private async _resolveTravelDestinationGeo(
        travel:TravelDetail,
        firstLocation?: { name?: string; lat?: number; lng?: number } | null,
    ): Promise<{
        locationLabel:string|null;
        coordinates:{ lat:number; lon:number }|null;
        countryAlpha2:string|null;
        countryAlpha3:string|null;
        countryName:string|null;
    }> {
        const empty = {
            locationLabel: null,
            coordinates: null,
            countryAlpha2: null,
            countryAlpha3: null,
            countryName: null,
        };
        const query = this._formatTravelLocationLabel(firstLocation, travel.destination?.country);
        const hasCoords = firstLocation?.lat != null && firstLocation?.lng != null;

        if(!query && !hasCoords) {
            return empty;
        }

        try {
            await this.googleMapsService.loadMaps();
            const geocoder = new google.maps.Geocoder();

            let result: google.maps.GeocoderResult = null;

            if(hasCoords) {
                const reverse = await geocoder.geocode({
                    location: { lat: firstLocation.lat, lng: firstLocation.lng }
                });
                result = reverse.results?.[0] || null;
            }

            if(!result && query) {
                const forward = await geocoder.geocode({ address: query });
                result = forward.results?.[0] || null;
            }

            if(!result) {
                return {
                    locationLabel: query,
                    coordinates: hasCoords
                        ? { lat: firstLocation.lat, lon: firstLocation.lng }
                        : null,
                    countryAlpha2: null,
                    countryAlpha3: null,
                    countryName: null,
                };
            }

            const countryComponent = result.address_components?.find((c) => c.types?.indexOf('country') !== -1);
            const countryAlpha2 = countryComponent?.short_name || null;
            const countryName = countryComponent?.long_name || null;
            const countryAlpha3 = PGUtilities.countryAlpha2ToAlpha3(countryAlpha2);
            const parsed = PGUtilities.parseAddressComponents(result.address_components);
            const coordinates = {
                lat: result.geometry.location.lat(),
                lon: result.geometry.location.lng(),
            };
            const locationLabel = [parsed.city || firstLocation?.name, countryName || parsed.country]
                .filter(Boolean)
                .join(', ') || query;

            return { locationLabel, coordinates, countryAlpha2, countryAlpha3, countryName };
        }
        catch(ex) {
            console.warn('Travel destination geocode failed', ex);
            return {
                locationLabel: query,
                coordinates: hasCoords
                    ? { lat: firstLocation.lat, lon: firstLocation.lng }
                    : null,
                countryAlpha2: null,
                countryAlpha3: null,
                countryName: null,
            };
        }
    }

    private _countryDisplayName(countryCode?:string) {
        if(!countryCode) return null;
        const alpha2 = PGUtilities.countryAlpha3ToAlpha2(countryCode);
        if(!alpha2) return null;

        try {
            const lang = (this.localizationService.currentLanguage || 'it_IT').split('_')[0];
            return new Intl.DisplayNames([lang], { type: 'region' }).of(alpha2) || null;
        }
        catch {
            return null;
        }
    }

    private _formatTravelLocationLabel(location?: { name?: string; lat?: number; lng?: number }, country?: string) {
        const name = location?.name?.trim();
        const countryLabel = country?.trim();
        if(name && countryLabel) {
            if(name.toLowerCase() === countryLabel.toLowerCase()) return name;
            return name + ', ' + countryLabel;
        }
        return name || countryLabel || null;
    }

    private _loadTourOperatorDataFinish(config)  {
        this.areWidgetsInitialized = false;
        this._rebuildTourSteps(config);
        this.widgetList = config;
        this.showBackgroundMap = true;

        this._fadeWidgetsTimeout = setTimeout(() => {
            this.fadeWidgets = false;
        }, 250)
    }

    private async _checkLocation() {
        if(this.configData.location != null && this.configData.location != '') {
            if(typeof this.configData.location == 'string') {
                this.currentLocation = this.configData.location; 
                
                await this._geocodeCurrentLocationToCurrentCoordinates()
            }
            else if(typeof this.configData.location == 'object') {
                if('coordinates' in this.configData.location) {
                    let _coordinates = this.configData.location.coordinates

                    this.currentCoordinates = {
                        lat: _coordinates[0],
                        lon: _coordinates[1],
                    }
                    
                    await this._geocodeCurrentCoordinatesToCurrentLocation()
                }
            }
        }
        else {
            // no configured location: leave map/weather empty
        }

        await this._loadCurrentWeatherForCurrentLocation()

        console.log('homeVariables', this.homeVariables)
    }

    private async _geocodeCurrentCoordinatesToCurrentLocation() {
        this.currentLocation = null;

        try {    
            await this.googleMapsService.loadMaps()

            let _geocoder = new google.maps.Geocoder()
            let _data = await _geocoder.geocode({
                location: {
                    lat: this.currentCoordinates.lat, 
                    lng: this.currentCoordinates.lon
                }
            })
    
            if(_data.results != null && _data.results.length > 0) {
                let _parsed = PGUtilities.parseAddressComponents(_data.results[0].address_components)
                this.currentLocation = _parsed.city + ',' + _parsed.province + ',' + _parsed.country
            }
        }
        catch(ex) {
            console.log(ex)
        }
    }

    private async _geocodeCurrentLocationToCurrentCoordinates() {
        try {
            await this.googleMapsService.loadMaps();

            let _geocoder = new google.maps.Geocoder()

            let _data = await _geocoder.geocode({
                address: this.currentLocation
            })
    
            if(_data.results != null && _data.results.length > 0) {
                this.currentCoordinates = {
                    lat: _data.results[0].geometry.location.lat(),
                    lon: _data.results[0].geometry.location.lng()
                }
            }
        }
        catch(ex) {
            console.log(ex)
        }
    }

    private _loadCurrentWeatherForCurrentLocation() {
        return new Promise<void>((resolve, reject) => {
            this.weatherService.getForecastWeather(this.currentLocation).subscribe((data) => {
                for(let i in this.homeVariables.weather) {
                    this.homeVariables.weather[i] = false;
                }

                this.homeVariables.weather.sunny = true;

                for(let _item of data[0].list) {
                    let _category = _item.getCategory()
                    if(_category == 'Drizzle' || _category == 'Rain' || _category == 'Thunderstorm' || _category == 'Snow') {
                        let _mmAve = _item.pop * (_item.rain != null ? _item.rain['3h'] : 0) + (_item.snow != null ? _item.snow['3h'] : 0) / 3;

                        // moltiplico pop (probabilità di precipitazioni) per i mm in 3 ore e divido per 3, in modo da avere i mm moltiplicati per la chanche
                        // do pioggia se c'è almeno 1 mm di pioggia all'ora

                        if(_mmAve > 1) {
                            this.homeVariables.weather.rainy = true

                            if(_mmAve > 3) this.homeVariables.weather.sunny = false
                        }
                        break;
                    }

                    if(_item.getTemperature('feels') > 35) {
                        this.homeVariables.weather.intense_heat = true;
                        break;
                    }
                }

                this._refreshWeatherTimeout = setTimeout(() => {
                    this._loadCurrentWeatherForCurrentLocation();
                }, this._refreshWeatherDelay)

                resolve();
            }, () => {
                resolve()
            })
        })
    }

    @ViewChildren('widgetComponents') widgetComponents:QueryList<TotemWidget>;

    private _isTotemLoaded = false;
    private _areWidgetsInitializing = false;

    areWidgetsInitialized = false;

    ngAfterViewChecked(): void {
        this._applyOverlayFocus();

        if(this._isTotemLoaded && !this.areWidgetsInitialized && !this._areWidgetsInitializing) {
            this._areWidgetsInitializing = true;

            setTimeout(() => {
                for(let i = 0; i < this.widgetComponents.length; i++) {
                    let _component = this.widgetComponents.find((item, index) => { return index == i })
                    
                    this.widgetList[i].size = _component.size;
                }

                this._areWidgetsInitializing = false;
                this.areWidgetsInitialized = true;

                this.checkScroll()

                if (this._pendingTourDayApply) {
                    this._pendingTourDayApply = false;
                    this.applyTourDaySelection();
                }
            }, 100)
        }
    }

    showFullScreen = false;

    fullScreenWidget:TotemHomeComponentWidgetData = null;
    fullScreenParams:any = null;

    private _getFragment(widget?:TotemHomeComponentWidgetData, params?:any) {
        let _result = ''

        if(widget) {
            _result += widget.id;

            let _params = ''
            if(params != null && params !== '') {
                if(typeof params == 'object') _params = JSON.stringify(params)
                else _params = String(params)
            }

            if(_params !== '') {
                _result += '/' + encodeURIComponent(_params)
            }
        }

        return _result;
    }

    private _toggleFullScreenTimeout = null;
    
    onRequestFullScreen(widget:TotemHomeComponentWidgetData, event:{ widget?:string, params?:any }) {
        let _target = widget;
 
        if(event?.widget) {
            _target = null;

            for(let _item of this.widgetList) {
                if(_item.id == event.widget || _item.name == 'totem-widget-' + event.widget) {
                    _target = _item;
                    break;
                }
            }
        }

        if(_target != null && (this.fullScreenWidget != _target || this.fullScreenParams !== event?.params)) {
            this.analyticsService.sendEvent('widgetFullScreen', {
                widget_id: widget.id,
                widget_type: widget.name,
                widget_params: event?.params,
            })

            this.router.navigate(['.'], { fragment: this._getFragment(_target, event?.params), relativeTo: this.route })
        }
    }

    hideFullScreen() {
        this.router.navigate(['.'], { fragment: this._getFragment(), relativeTo: this.route })
    }

    @ViewChild('homeElement') homeElement:ElementRef;

    private _screensaverTimeout = null;
    private _widgetFlipInterval = null;

    private _widgetFlipIndex = 0;

    resetInactivity() { // TODO: resettare anche su inactivity
        this.stopScreenSaver();
        clearTimeout(this._screensaverTimeout);

        this._screensaverTimeout = setTimeout(() => {
            this.startScreenSaver();
        }, 1000 * 30)

        clearInterval(this._widgetFlipInterval)

        if(this.prefersReducedMotion()) {
            return;
        }

        this._widgetFlipInterval = setInterval(() => {
            if(this.homeElement != null) {
                for(let i = 0; i < this.widgetComponents.length; i++) {
                    let _component = this.widgetComponents.find((item, index) => { return index == i })
    
                    _component.onInactive()
                }
    
                let _homeRect = this.homeElement.nativeElement.getBoundingClientRect(); 

                for(let i = 0; i < this.widgetComponents.length; i++) {
                    let _index = this._widgetFlipIndex % this.widgetComponents.length;
    
                    this._widgetFlipIndex++;
    
                    let _component = this.widgetComponents.find((item, index) => { return index == _index })
     
                    if(_component.hasInactiveFlip && _component.elementRef != null) {
                        let _rect = _component.elementRef.nativeElement.getBoundingClientRect();

                        if(_rect.width > 0 &&
                            _rect.height > 0 &&
                            _rect.top < _homeRect.bottom &&
                            _rect.bottom > _homeRect.top) {
    
                            _component.onInactiveFlip()
                            break;
                        }
                    }
                }
            }
        }, 5000 * 1)
    }

    screenSaverData:TotemScreensaverData = null;

    private _screenSaverIndex = 0;

    startScreenSaver() {
        if(this.environmentService.ElectronWrapper != null && this.screenSaverData == null) {
            this.screenSaverData = this.configData.screenSaver[this._screenSaverIndex];
        }
    }

    stopScreenSaver() {
        if(this.screenSaverData != null) {
            this.screenSaverData = null;
            this._screenSaverIndex = (this._screenSaverIndex + 1) % this.configData.screenSaver.length;
        }
    }

    onScreensaverPlayComplete() {
        this.resetInactivity();
    }

    isChatEnabled() {
        return this.environmentService.isWebsocketEnabled() && !this.configData?.disableChat;
    }

    goToCustomerCareBooking() {
        this.router.navigate(['/book-customer-care'])
    }

    requiresLogin() {
        return !this.authService.isLoggedIn()
    }

    @ViewChild('backgroundElement') backgroundElement:ElementRef;
    @ViewChild('contentElement') contentElement:ElementRef;

    checkScroll() {
        // Avoid parallax jumps while overlays remount/replace home widgets
        if(this.showFullScreen || this.viewProductId || this.showSplashScreen) return;

        let _backgroundElement = (this.backgroundElement.nativeElement as HTMLDivElement)
        let _contentElement = (this.contentElement.nativeElement as HTMLDivElement)

        _backgroundElement.style.transform = 'translate(0, -' + ((_contentElement.scrollTop / (_contentElement.scrollHeight - _contentElement.offsetHeight)) * 20) + '%)'
    }

    isWidgetConditionTrue(widget:TotemHomeComponentWidgetData) {
        if (widget.name === 'totem-widget-details'
            && (widget.id === 'customization-details' || widget.id === 'departure-logistic-details')) {
            const list = widget.params?.detailList;
            if (!Array.isArray(list) || !list.length) return false;
        }

        if(widget.condition == null || widget.condition == '') return true;
        else {
            if(widget.condition == 'never') return false;
            else {
                let _split = widget.condition.split('.')
    
                let _value:any = this.homeVariables

                while(_split.length > 0) {
                    _value = _value[_split.shift()]
                    if(_value == null) break
                }
                
                return _value == true;
            }
        }
    }

    @ViewChild('viewProductComponent') viewProductComponent:TotemProductComponent

    getViewProductTitle() {
        if(this.viewProductComponent) return this.viewProductComponent.productData?.getTranslatedProductField('title')
        return '';
    }

    hasFullscreenTitle() {
        return this.fullScreenWidget?.name != 'totem-widget-products';
    }

    hasFullscreenBack() {
        return this.fullScreenWidget?.name == 'totem-widget-products';
    }

    hasFullscreenButton(widget:TotemHomeComponentWidgetData) {
        if(widget.name == 'totem-widget-products' && !widget.params?.noFullScreen) {
            return 'totem-widget-products.show-all';
        }
    }

    isRealFullscreen() {
        return this.fullScreenWidget != null
            && this.fullScreenWidget.name == 'totem-widget-products'
            && this.fullScreenParams == null;
    }
}
